<template>
  <div class="FilterTrips">
    <select class="small" v-model="status">
      <option value="active">Active</option>
      <option value="inactive">Inactive</option>
      <option value="all">All Trips</option>
    </select>
    <div class="large tabs three">
      <input  id="tab-2a" name="group1" type="radio" value="active" v-model="status">
      <label for="tab-2a" class="pseudo button toggle">Active</label>
      <input  id="tab-3a" name="group1" type="radio" value="inactive" v-model="status">
      <label for="tab-3a" class="pseudo button toggle">Inactive</label>
      <input  id="tab-1a" name="group1" type="radio" value="all" v-model="status">
      <label for="tab-1a" class="pseudo button toggle">All Trips</label>
    </div>
    <select class="small" v-model="date">
      <option value="all">All Time</option>
      <option value="today">Today</option>
      <option value="week">This Week</option>
    </select>
    <div class="large tabs two">
      <input  id="tab-1b" type="radio" value="all" v-model="date">
      <label for="tab-1b" class="pseudo button toggle">All Time</label>
      <input  id="tab-2b" type="radio" value="today" v-model="date">
      <label for="tab-2b" class="pseudo button toggle">Today</label>
      <input  id="tab-3b" type="radio" value="week" v-model="date">
      <label for="tab-3b" class="pseudo button toggle">This Week</label>
    </div>
  </div>
</template>

<style lang="less">
.FilterTrips {
  margin: 0 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .tabs {
    float: left;
  }
  .button {
    color: white;
  }
  select {
    color: black;
    max-width: 20em;
  }
  z-index: 10;
  
  @media (max-width: 1270px) {
    .large {
      display: none;
    }
  }
  @media (min-width: 1270px) {
    .small {
      display: none;
    }
  }
}
</style>

<script>
export default {
  data () {
    return {
      status: 'active',
      date:  'all'
    }
  },
  watch: {
    status (value) {
      this.$emit('status', value)
    },
    date (value) {
      this.$emit('date', value)
    }
  }
}
</script>